// /src/translations/intakeFormTexts.js

export const intakeFormTexts = {
  es: {
    title: "Formulario de Ingreso",
    personalData: "Datos Personales",

    namePlaceholder: "Nombre completo",
    emailPlaceholder: "Correo electrónico",
    phonePlaceholder: "Teléfono",
    agePlaceholder: "Edad",

    objectiveTitle: "Objetivo del masaje",
    objectiveOptions: [
      "Relajación",
      "Dolor específico",
      "Estrés / ansiedad",
      "Recuperación física",
      "Otro",
    ],

    painAreasTitle: "Zonas de dolor o tensión",
    painAreas: [
      "Espalda alta",
      "Espalda baja",
      "Cuello",
      "Hombros",
      "Piernas",
      "Brazos",
      "Cabeza",
      "Ciática",
    ],

    medicalHistoryTitle: "Historial médico",
    medicalHistory: [
      "Presión alta",
      "Problemas cardíacos",
      "Varices",
      "Lesión reciente",
      "Operación reciente",
      "Sensibilidad extrema",
      "Problemas articulares",
    ],

    allergiesTitle: "Alergias o medicamentos",
    allergiesPlaceholder: "Alergias (si aplica)",
    medicationsPlaceholder: "Medicamentos (si aplica)",

    pregnancyTitle: "¿Estás embarazada?",
    pregnancyWeeksPlaceholder: "Semanas de embarazo",

    contraindicationsTitle: "Contraindicaciones",
    contraindications: [
      "Fiebre",
      "Infecciones",
      "Enfermedades contagiosas",
      "Problemas severos de piel",
      "Coágulos sanguíneos",
    ],

    notesTitle: "Notas adicionales",
    notesPlaceholder: "Escribe cualquier información adicional",

    consentText:
      "Confirmo que este formulario ha sido completado por mí (la persona que recibirá el tratamiento) y que toda la información proporcionada es verdadera y correcta según mi conocimiento.",

    sendButton: "Enviar formulario",
    closeButton: "Cerrar",

    successMessage: "Hemos recibido tu información.\n\nPronto me pondré en contacto contigo utilizando el correo electrónico o el número de WhatsApp que proporcionaste.\n\nPor favor, revisa también tu carpeta de correo no deseado (spam), ya que algunos mensajes pueden llegar allí por error.",
    errorMessage: "Error al enviar el formulario",
  },

  // --- INGLÉS ---
  en: {
    title: "Intake Form",
    personalData: "Personal Information",

    namePlaceholder: "Full name",
    emailPlaceholder: "Email address",
    phonePlaceholder: "Phone number",
    agePlaceholder: "Age",

    objectiveTitle: "Massage Objective",
    objectiveOptions: [
      "Relaxation",
      "Specific pain",
      "Stress / anxiety",
      "Physical recovery",
      "Other",
    ],

    painAreasTitle: "Areas of pain or tension",
    painAreas: [
      "Upper back",
      "Lower back",
      "Neck",
      "Shoulders",
      "Legs",
      "Arms",
      "Head",
      "Sciatica",
    ],

    medicalHistoryTitle: "Medical history",
    medicalHistory: [
      "High blood pressure",
      "Heart issues",
      "Varicose veins",
      "Recent injury",
      "Recent surgery",
      "Extreme sensitivity",
      "Joint problems",
    ],

    allergiesTitle: "Allergies or medication",
    allergiesPlaceholder: "Allergies (if any)",
    medicationsPlaceholder: "Medications (if any)",

    pregnancyTitle: "Are you pregnant?",
    pregnancyWeeksPlaceholder: "Weeks of pregnancy",

    contraindicationsTitle: "Contraindications",
    contraindications: [
      "Fever",
      "Infections",
      "Contagious diseases",
      "Severe skin issues",
      "Blood clots",
    ],

    notesTitle: "Additional notes",
    notesPlaceholder: "Write any additional information here",

    consentText:
      "I confirm that this form has been completed by me (the person receiving the treatment) and that all provided information is true and correct to the best of my knowledge.",

    sendButton: "Submit form",
    closeButton: "Close",

    successMessage: "We have received your information.\n\nI will contact you as soon as possible using the email address or WhatsApp number you provided.\n\nPlease also check your spam or junk mail folder, as some messages may occasionally end up there.",
    errorMessage: "Error sending form",
  },

   // --- ITALIANO ---
   it: {
    title: "Modulo di Ingresso",
    personalData: "Dati Personali",

    namePlaceholder: "Nome completo",
    emailPlaceholder: "Email",
    phonePlaceholder: "Telefono",
    agePlaceholder: "Età",

    objectiveTitle: "Obiettivo del massaggio",
    objectiveOptions: [
      "Rilassamento",
      "Dolore specifico",
      "Stress / ansia",
      "Recupero fisico",
      "Altro",
    ],

    painAreasTitle: "Zone di dolore o tensione",
    painAreas: [
      "Schiena alta",
      "Schiena bassa",
      "Collo",
      "Spalle",
      "Gambe",
      "Braccia",
      "Testa",
      "Sciatica",
    ],

    medicalHistoryTitle: "Storia medica",
    medicalHistory: [
      "Pressione alta",
      "Problemi cardiaci",
      "Vene varicose",
      "Lesione recente",
      "Operazione recente",
      "Sensibilità estrema",
      "Problemi articolari",
    ],

    allergiesTitle: "Allergie o farmaci",
    allergiesPlaceholder: "Allergie (se applicabile)",
    medicationsPlaceholder: "Farmaci (se applicabile)",

    pregnancyTitle: "Sei incinta?",
    pregnancyWeeksPlaceholder: "Settimane di gravidanza",

    contraindicationsTitle: "Controindicazioni",
    contraindications: [
      "Febbre",
      "Infezioni",
      "Malattie contagiose",
      "Problemi cutanei gravi",
      "Coaguli di sangue",
    ],

    notesTitle: "Note aggiuntive",
    notesPlaceholder: "Scrivi qualsiasi informazione aggiuntiva",

    consentText:
      "Confermo che questo modulo è stato compilato da me (la persona che riceverà il trattamento) e che tutte le informazioni fornite sono vere e corrette secondo la mia conoscenza.",

    sendButton: "Invia modulo",
    closeButton: "Chiudi",

    successMessage: "Abbiamo ricevuto le tue informazioni.\n\nTi contatterò al più presto tramite l'indirizzo email o il numero WhatsApp che hai fornito.\n\nTi consiglio inoltre di controllare la cartella spam o posta indesiderata, poiché alcuni messaggi potrebbero finire lì per errore.",
    errorMessage: "Errore nell'invio del modulo",
  },

   // --- ISLANDES ---
  is: {
  title: "Inntökueyðublað",
  personalData: "Persónuupplýsingar",

  namePlaceholder: "Fullt nafn",
  emailPlaceholder: "Tölvupóstur",
  phonePlaceholder: "Sími",
  agePlaceholder: "Aldur",

  objectiveTitle: "Markmið nuddmeðferðar",
  objectiveOptions: [
    "Slökun",
    "Sértækur verkur",
    "Streita / kvíði",
    "Líkamleg endurheimt",
    "Annað",
  ],

  painAreasTitle: "Svæði með verki eða spennu",
  painAreas: [
    "Efri bak",
    "Neðri bak",
    "Háls",
    "Axlar",
    "Fætur",
    "Handleggir",
    "Höfuð",
    "Ischias",
  ],

  medicalHistoryTitle: "Heilsufarssaga",
  medicalHistory: [
    "Háþrýstingur",
    "Hjartavandamál",
    "Æðahnútar",
    "Nýleg meiðsli",
    "Nýleg aðgerð",
    "Mikil næmni",
    "Liðavandamál",
  ],

  allergiesTitle: "Ofnæmi eða lyf",
  allergiesPlaceholder: "Ofnæmi (ef við á)",
  medicationsPlaceholder: "Lyf (ef við á)",

  pregnancyTitle: "Ertu ólétt?",
  pregnancyWeeksPlaceholder: "Vikur gengin",

  contraindicationsTitle: "Frábendingar",
  contraindications: [
    "Hiti",
    "Sýkingar",
    "Smitandi sjúkdómar",
    "Alvarleg húðvandamál",
    "Blóðtappi",
  ],

  notesTitle: "Aukatilkynningar",
  notesPlaceholder: "Skrifaðu aðrar upplýsingar hér",

  consentText:
    "Ég staðfesti að þetta eyðublað hefur verið fyllt út af mér (personunni sem mun fá meðferðina) og að allar upplýsingar sem gefnar eru eru réttar eftir því sem ég best veit.",

  sendButton: "Senda eyðublað",
  closeButton: "Loka",

  successMessage: "Við höfum móttekið upplýsingarnar þínar.\n\nÉg mun hafa samband við þig eins fljótt og auðið er í gegnum netfangið eða WhatsApp númerið sem þú gafst upp.\n\nVinsamlegast athugaðu einnig ruslpóstsmöppuna þína (spam), þar sem skilaboð geta stundum lent þar fyrir mistök.",
  errorMessage: "Villa kom upp við að senda eyðublaðið",
},

// --- POLACO ---
de: {
  title: "Formularz zgłoszeniowy",
  personalData: "Dane osobowe",

  namePlaceholder: "Imię i nazwisko",
  emailPlaceholder: "Adres e-mail",
  phonePlaceholder: "Numer telefonu",
  agePlaceholder: "Wiek",

  objectiveTitle: "Cel masażu",
  objectiveOptions: [
    "Relaks",
    "Konkretny ból",
    "Stres / lęk",
    "Regeneracja fizyczna",
    "Inny",
  ],

  painAreasTitle: "Obszary bólu lub napięcia",
  painAreas: [
    "Górna część pleców",
    "Dolna część pleców",
    "Szyja",
    "Barki",
    "Nogi",
    "Ramiona",
    "Głowa",
    "Rwa kulszowa",
  ],

  medicalHistoryTitle: "Historia medyczna",
  medicalHistory: [
    "Nadciśnienie",
    "Problemy z sercem",
    "Żylaki",
    "Niedawny uraz",
    "Niedawna operacja",
    "Nadmierna wrażliwość",
    "Problemy ze stawami",
  ],

  allergiesTitle: "Alergie lub leki",
  allergiesPlaceholder: "Alergie (jeśli występują)",
  medicationsPlaceholder: "Przyjmowane leki (jeśli występują)",

  pregnancyTitle: "Czy jesteś w ciąży?",
  pregnancyWeeksPlaceholder: "Tydzień ciąży",

  contraindicationsTitle: "Przeciwwskazania",
  contraindications: [
    "Gorączka",
    "Infekcje",
    "Choroby zakaźne",
    "Poważne problemy skórne",
    "Zakrzepy krwi",
  ],

  notesTitle: "Dodatkowe informacje",
  notesPlaceholder: "Wpisz dodatkowe informacje",

  consentText:
    "Potwierdzam, że formularz został wypełniony przeze mnie (osobę poddawaną zabiegowi) oraz że wszystkie podane informacje są zgodne z moją najlepszą wiedzą i prawdziwe.",

  sendButton: "Wyślij formularz",
  closeButton: "Zamknij",

  successMessage: "Otrzymaliśmy Twoje informacje.\n\nSkontaktuję się z Tobą tak szybko, jak to możliwe za pośrednictwem adresu e-mail lub numeru WhatsApp, który podałeś.\n\nProszę również sprawdzić folder spam, ponieważ wiadomości mogą czasami trafić tam przez pomyłkę.",
  errorMessage: "Wystąpił błąd podczas wysyłania formularza",
  }
};
